export default {
  failed_to_open: "Impossible d'ouvrir l'intégration pour ce restaurant. Veuillez réessayer.",
};
